import React from 'react';
import { Link } from 'react-router-dom';
import { MapPin, Maximize2, Building2 } from 'lucide-react';
import { formatArea, formatBudgetRange, propertyTypeLabel, statusLabel } from '@/lib/format';
import { Badge } from '@/components/ui/badge';

export default function PropertyCard({ property, testId }) {
  if (!property) return null;
  const img = property.images?.[0] || 'https://images.unsplash.com/photo-1497366216548-37526070297c?auto=format&fit=crop&w=2000&q=80';
  return (
    <Link
      to={`/properties/${property.slug || property.id}`}
      data-testid={testId || 'property-card'}
      className="group flex h-full flex-col overflow-hidden rounded-xl border border-slate-200 bg-white shadow-sm hover:shadow-md transition-shadow"
    >
      <div className="relative aspect-[16/10] overflow-hidden">
        <img
          src={img}
          alt={property.title}
          loading="lazy"
          className="h-full w-full object-cover transition-transform duration-[600ms] ease-out group-hover:scale-[1.04]"
        />
        <div className="absolute left-3 top-3 flex gap-2">
          <Badge className="rounded-md bg-[#144726] text-white hover:bg-[#144726] border-0">{propertyTypeLabel(property.property_type)}</Badge>
          {property.status && property.status !== 'available' && (
            <Badge className="rounded-md bg-[#C6A35B] text-[#144726] hover:bg-[#C6A35B] border-0">{statusLabel(property.status)}</Badge>
          )}
        </div>
      </div>
      <div className="flex flex-1 flex-col p-5">
        <h3 className="font-display text-xl font-semibold text-[#144726] tracking-tight line-clamp-2">{property.title}</h3>
        <div className="mt-2 flex items-center gap-2 text-sm text-slate-500">
          <MapPin className="h-4 w-4 text-[#C6A35B]" />
          <span>{property.location}</span>
        </div>
        <div className="mt-4 grid grid-cols-2 gap-3 text-sm">
          <div className="flex items-center gap-2 text-slate-600"><Maximize2 className="h-4 w-4 text-slate-400" />{formatArea(property.area_sqft)}</div>
          <div className="flex items-center gap-2 text-slate-600"><Building2 className="h-4 w-4 text-slate-400" />{propertyTypeLabel(property.property_type)}</div>
        </div>
        <div className="mt-4 border-t border-slate-100 pt-4">
          <p className="text-xs uppercase tracking-wider text-slate-500">Indicative rent</p>
          <p className="mt-1 text-sm font-semibold text-[#144726]">{formatBudgetRange(property.budget_min, property.budget_max)}</p>
        </div>
      </div>
    </Link>
  );
}
